import { render, staticRenderFns } from "./LegalFeesCalculatorModal.vue?vue&type=template&id=2ad938a6"
import script from "./LegalFeesCalculatorModal.vue?vue&type=script&lang=js"
export * from "./LegalFeesCalculatorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports